<footer class="footer mt-auto footer-light small">
    <div class="container-fluid">
        <hr />
        <div class="row">
            <div class="col-6">
                &copy; United Way, {{getCurrentYear()}}.  {{ "footer.rights" | translate }}
            </div>
            <div class="col-6 text-md-right">
                <a href="{{ 'external_links.legal_url' | translate }}" target="_blank">{{ "footer.legal" | translate }}</a>
                <span class="ml-2 mr-2">|</span>
                <a href="{{ 'external_links.privacy_url' | translate }}" target="_blank">{{ "footer.privacy" | translate }}</a>
                <span class="ml-2 mr-2">|</span>
                <a href="{{ 'external_links.terms_url' | translate }}" target="_blank">{{ "footer.terms" | translate }}</a>
            </div>
        </div>
    </div>
</footer>
